import { RangeCalendarHeader_default } from "../RangeCalendar/RangeCalendarHeader.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/DateRangePicker/DateRangePickerHeader.vue?vue&type=script&setup=true&lang.ts
var DateRangePickerHeader_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "DateRangePickerHeader",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(RangeCalendarHeader_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/DateRangePicker/DateRangePickerHeader.vue
var DateRangePickerHeader_default = DateRangePickerHeader_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { DateRangePickerHeader_default };
//# sourceMappingURL=DateRangePickerHeader.js.map